export const FEATURES_SURE_TYPE_GET_REQUESTING = 'FEATURES_SURE_TYPE_GET_REQUESTING';
export const FEATURES_SURE_TYPE_GET_SUCCESS = 'FEATURES_SURE_TYPE_GET_SUCCESS';
export const FEATURES_SURE_TYPE_GET_ERROR = 'FEATURES_SURE_TYPE_GET_ERROR';